
const digest = '36c5ed4dd610a717fce2aac899d7d82a3dd9ef2596dae6dc4570530fb31ffa3c';
const classes = {"wrapper":"_wrapper_5rt7q_1","selected":"_selected_5rt7q_11"};
const css = `._wrapper_5rt7q_1 {
  font-family: Rubik, "sans-serif";
  background: #f6f6f8;
  display: flex;
  flex-direction: row;
  gap: 30px;
  align-items: center;
  padding: 12px 34px;
  justify-content: space-between;
}
._wrapper_5rt7q_1 ._selected_5rt7q_11 {
  font-weight: 500;
  font-size: 14px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  